import { useState } from "react";



function BetSlip({ team, onCancel, onSubmit }) {
  const [odds, setOdds] = useState(team.odds);
  const [stake, setStake] = useState(100);

  const MIN_STAKE = 10;
  const MAX_STAKE = 500000;

  const QUICK_AMOUNTS = [
    100,
    500,
    1000,
    2000,
    5000,
    10000,
    50000,
    1000000
  ];

  const addStake = (amount) =>
    setStake((s) => Math.min(s + amount, MAX_STAKE));

  

  return (
    <div style={s.wrapper}>
      <div style={s.teamName}>{team.name}</div>

      {/* TOP ROW */}
      <div style={s.row}>
        {/* ODDS */}
        <div style={s.col}>
          <div style={s.label}>Odds</div>

          <div style={s.oddsBox}>
            <button
              style={s.oddsBtn}
              onClick={() => setOdds((o) => Math.max(1, o - 1))}
            >
              −
            </button>

            <span style={s.oddsVal}>{odds}</span>

            <button
              style={s.oddsBtn}
              onClick={() => setOdds((o) => o + 1)}
            >
              +
            </button>
          </div>
        </div>

        {/* STAKE */}
        <div style={s.col}>
          <div style={s.stakeHeader}>
            <span style={s.label}>Stake</span>

            <span style={s.minMax}>
              Min:10 | Max:5L
            </span>
          </div>

          <div style={s.stakeBox}>
            {stake.toLocaleString("en-IN")}
          </div>
        </div>
      </div>

      {/* QUICK BUTTONS */}
      <div style={s.grid4}>
        {QUICK_AMOUNTS.map((amt) => (
          <button
            key={amt}
            style={s.quickBtn}
            onClick={() => addStake(amt)}
          >
            
            {amt }
          </button>
        ))}
      </div>

      {/* ACTION BUTTONS */}
      <div style={s.grid4}>
        <button
          style={{ ...s.actionBtn, ...s.min }}
          onClick={() => setStake(MIN_STAKE)}
        >
          MIN
        </button>

        <button
          style={{ ...s.actionBtn, ...s.max }}
          onClick={() => setStake(MAX_STAKE)}
        >
          MAX
        </button>

        <button
          style={{ ...s.actionBtn, ...s.allin }}
          onClick={() => setStake(MAX_STAKE)}
        >
          All IN
        </button>

        <button
          style={{ ...s.actionBtn, ...s.clear }}
          onClick={() => setStake(0)}
        >
          CLEAR
        </button>
      </div>

      {/* FOOTER BUTTONS */}
      <div style={s.footerRow}>
        <button style={s.cancelBtn} onClick={onCancel}>
          Cancel
        </button>

        <button
          style={s.submitBtn}
          onClick={() => onSubmit?.({ team, odds, stake })}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default BetSlip;

const s = {
  wrapper: {
    background: "#A7D4F6",
    borderRadius: "6px",
    padding: "16px",
    fontFamily: "Poppins, sans-serif",
    width: "100%",
    boxSizing: "border-box",
    height:"230px"
  },

  teamName: {
    fontWeight: "600",
    fontSize: "13px",
    color: "#1D1D1D",
    marginBottom: "2px",
    marginTop:"-9px"
  },

  row: {
    display: "flex",
    gap: "12px",
    marginBottom: "10px",
    alignItems: "flex-end",
  },

  col: {
    flex: 1,
  },

  label: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#1D1D1D",

  },

  stakeHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "3px",
  },

  minMax: {
    fontSize: "13px",
    color: "#1D1D1D",
    fontWeight: "400",
  },

  oddsBox: {
    display: "flex",
   
    overflow: "hidden",
    height: "28px",
    background: "#FFFFFF",
  },

  oddsBtn: {
    width: "44px",
    border: "none",
    background: "#00539C",
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  
  },

  oddsVal: {
    flex: 1,
    background: "#F2F2F2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "600",
    color: "#1D1D1D",

  },

  stakeBox: {
    background: "#F2F2F2",
  
    height: "54px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "400",
    fontSize: "14px",
    color: "#1D1D1D",
     height: "28px",
  },

  grid4: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "10px",
    marginBottom: "9px",
  },

  quickBtn: {
    background: "#D3EBFF",
    border: "none",
  
    height: "26px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#115F9C",
    cursor: "pointer",
  },

  actionBtn: {
    border: "none",
  
    height: "26px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
  },

  min: {
    background: "#C9FFBC",
    color: "#0E6F25",
  },

  max: {
    background: "#F5DEAE",
    color: "#7B4F00",
  },

  allin: {
    background: "#FFA9A9",
    color: "#740002",  
  },

  clear: {
   background: "#DB3434",
    color: "#FFFFFF",
  },

  footerRow: {
    display: "flex",
    gap: "12px",
    marginTop: "10px",
  },

  cancelBtn: {
    flex: 1,
    height: "30px",
    background: "#FF6A6A",
// border: "0.8px solid #212121",
    border:"none",
    fontSize: "14px",
    fontWeight: "500",
    color: "#212121",
    cursor: "pointer",
  },

  submitBtn: {
    flex: 1,
    height: "30px",
    background: "#49A712",
    border: "none",
   
    fontSize: "14px",
    fontWeight: "600",
    color: "#FFFFFF",
    cursor: "pointer",
  },
};